var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 .472c-11.045 0-20 8.954-20 20 0 11.045 8.955 20 20 20s20-8.955 20-20c0-11.046-8.955-20-20-20zm8.822 10h-3.069L20.7 16.37l-4.367-5.898H10l7.566 10.092-7.167 8.37h3.06l5.535-6.458 4.83 6.457H30l-7.881-10.641 6.703-7.82zm-2.447 16.587h-1.697L13.579 12.252h1.827l10.969 14.807z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.ff7435113ca89cd6b4ffb78856a037a5.svg";
export { ForwardRef as ReactComponent };